import { useMutation, useQuery } from "@apollo/client";
import {
  GOOGLE_BUSINESS_MANAGED_INFO_QUERY,
  NOTIFY_ADMIN_OF_PENDING_GOOGLE_BUSINESS_INVITATION_MUTATION,
} from "@/graphql/google-business";
import { useAsyncAction } from "@/lib/hooks/use-async-action";
import { useSalonStore } from "@/lib/store/salon";

export function useNotifyPendingInvitation() {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id;

  const { data: infoData, loading: infoLoading } = useQuery(GOOGLE_BUSINESS_MANAGED_INFO_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  const [notify] = useMutation(NOTIFY_ADMIN_OF_PENDING_GOOGLE_BUSINESS_INVITATION_MUTATION);

  const action = useAsyncAction(
    async () => {
      if (!salonId) throw new Error("No salon selected");
      const result = await notify({ variables: { salonId } });
      return result.data?.notifyAdminOfPendingGoogleBusinessInvitation ?? false;
    },
    {
      loadingMessage: "Notifying support...",
      successMessage: "We'll set you up within a few hours",
      errorMessage: "Could not notify support. Please try again or contact us directly.",
    }
  );

  return {
    defaultManagerEmail: infoData?.googleBusinessManagedInfo.defaultManagerEmail ?? null,
    infoLoading,
    notify: action.execute,
    notifying: action.isLoading,
  };
}
